import { useApolloClient } from "@apollo/client";
import {
  AdminAwxOrganizationStateDocument,
  AdminAwxOrganizationStateQuery,
  AwxLinkedAccountStatus,
} from "@common/utils/graphql";
import { useCallback } from "react";

export const useUpdateLinkedAccountStatus = () => {
  const client = useApolloClient();

  const updateLinkedkedAccountStatus = useCallback(
    (linkedAccountStatus: AwxLinkedAccountStatus) => {
      client.cache.updateQuery<AdminAwxOrganizationStateQuery>(
        { query: AdminAwxOrganizationStateDocument },
        (orgData) => {
          if (
            orgData?.awxOrganizationState?.__typename ===
            "QueryAwxOrganizationStateSuccess"
          ) {
            return {
              awxOrganizationState: {
                ...orgData?.awxOrganizationState,
                data: {
                  ...orgData?.awxOrganizationState.data,
                  linkedAccountStatus,
                },
              },
            };
          }
        },
      );
    },
    [client],
  );

  return updateLinkedkedAccountStatus;
};
